import SocialCredential from "./base";

const TikTok = SocialCredential.extend({
    parse: function (response) {
        response = TikTok.__super__.parse.apply(this, arguments);

        response.name = response.tikTokDisplayName;
        response.profileImage = response.tikTokAvatar;
        response.typeLabel = `TikTok`;
        response.platformType = `TikTok user`;

        return response;
    },

    isSocialMedia: function () {
        return true;
    },

    onShareSuccessful: function (response) {
        return TikTok.__super__.onShareSuccessful.call(
            this,
            `shareViaTiktokCount`,
            response
        );
    }
});

export default TikTok;
